<template>
    <div>
        <form @submit.prevent="submit" class="space-y-4">
            <InputField
                label="Username/NIM/NIDN"
                icon="user"
                v-model="form.username"
            />
            <InputError :message="form.errors.username" class="mt-2" />
            <InputField
                label="Sandi"
                :type="showPassword ? 'text' : 'password'"
                icon="key"
                v-model="form.password"
            />
            <InputError :message="form.errors.password" class="mt-2" />
            <label class="flex items-center mt-2">
                <input type="checkbox" v-model="showPassword" class="mr-2" />
                Show Password
            </label>

            <div class="mb-4">
                <label class="block text-sm font-medium">Pengguna</label>
                <select
                    v-model="form.role"
                    class="block w-full py-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                >
                    <option>Sebagai Pengguna</option>
                    <option value="4">Operator</option>
                    <option value="2">Dosen</option>
                    <option value="3" selected>Mahasiswa</option>
                </select>
            </div>
            <PrimaryBtn :disabled="form.processing" class="w-full"
                >Login</PrimaryBtn
            >
        </form>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import InputField from "@/Components/InputField.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputError from "@/Components/InputError.vue";

const form = useForm({
    username: "",
    password: "",
    role: "",
    remember: null,
});

defineProps({
    status: String,
});
const showPassword = ref(false);
const submit = () => {
    form.post(route("login"), {
        onFinish: () => form.reset("password"),
    });
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
